export default defineNuxtPlugin(async () => {
  const { getMasterQuotes } = useQuote();
  const isAuthenticated = computed(() => useCookie('isAuthenticated').value);

  const params: any = {
    fromCustomerAccount: true,
    pageable: { page: 0, size: 999 },
  };

  try {
    //isAuthenticated.value ? await getMasterQuotes(params) : null;
  } catch (error) {
    console.error('Error while fetching quote:', error);
  }
});
